import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getMissionHistory, getMissions, getMissionsDetail } from '../queries/getMissions.ts';

export const useMissions = (territorySlug: string, queryParams: Record<string, string>) => {
  return useQuery({
    queryKey: ['missions', territorySlug, queryParams],
    queryFn: ({ signal }) => getMissions(territorySlug, queryParams, signal),
    refetchInterval: 10000,
    placeholderData: keepPreviousData,
  });
};

export const useMission = (territorySlug: string, missionId: string) => {
  return useQuery({
    queryKey: ['mission', territorySlug, missionId],
    queryFn: ({ signal }) => getMissionsDetail(territorySlug, missionId, signal),
  });
};

export const useMissionHistory = (territorySlug: string, missionId: string) => {
  return useQuery({
    queryKey: ['mission-history', territorySlug, missionId],
    queryFn: ({ signal }) => getMissionHistory(territorySlug, missionId, signal),
  });
};
